module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1091.44f59b5c.jpg";